export default __webpack_public_path__ + "static/media/p3.a5c2d4d0.JPG";